<micro-picklist #picklist [all]="all" [(selectedIds)]="selectedItems" (selectedIdsChange)="onNgModelChange($event)"></micro-picklist>

